import { useTranslate } from "@tolgee/react";
import React, { Suspense } from "react";
import { Loading } from "src/components";

const Redirecting = React.lazy(() => import("./Redirecting"));

function RedirectingPage(props) {
  const { t } = useTranslate();
  return (
    <Suspense
      fallback={
        <Loading
          addContainer
          active
          loadingText={t({ key: "common.loading", defaultValue: "Loading" })}
        />
      }
    >
      <Redirecting {...props} />
    </Suspense>
  );
}

export default RedirectingPage;
